import { useModal } from 'contexts/modal-context';

export interface IModalOverlay {
  children: React.ReactNode;
  closeable?: boolean;
}

const ModalOverlay = ({ children, closeable = true }: IModalOverlay) => {
  const { closeModal } = useModal();

  return (
    <div
      className={`overflow-visible h-5/6 md:h-[600px] relative w-11/12 max-w-2xl rounded-2xl max-h-full flex flex-col`}
    >
      {closeable ? (
        <button
          className={`bg-none border-none text-darkBlue-100 text-3xl absolute top-2 right-2 cursor-pointer z-20`}
          onClick={closeModal}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            className="h-6 w-6"
          >
            <path
              fill="currentColor"
              d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
            />
          </svg>
        </button>
      ) : null}
      <div className="overflow-auto bg-white p-8 flex-1 rounded-2xl flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default ModalOverlay;
